import { authStore, useAuth } from '@jq4race/api-client';
import type { ReactNode } from 'react';

import { AuthStateContext } from '../modules/auth/ui/auth-state-context';

interface AuthStateProviderProps {
  children: ReactNode;
}

export function AuthStateProvider({ children }: AuthStateProviderProps) {
  const {
    session,
    isAuthenticated,
    sessionExpired,
    sessionExpiredReason,
    setSession,
    clearSessionExpired,
    expireSession,
    signOut,
  } = useAuth();

  return (
    <AuthStateContext.Provider
      value={{
        session,
        isAuthenticated,
        sessionExpired,
        sessionExpiredReason,
        setSession,
        clearSessionExpired,
        expireSession,
        signOut,
        getSession: () => authStore.get(),
      }}
    >
      {children}
    </AuthStateContext.Provider>
  );
}
